export default "__VITE_ASSET__03031b47__"